import React from 'react';
import DeleteModal from '../../../Modals/DeleteModal';
import ScheduleApp from './Functionality/ScheduleApp';
import MealsTable from './SubComponents/MealsTable';
import Shifts from './SubComponents/Shifts';
import {permissionObj} from '../../../../Helpers/permission';
import {SUB_VIEW_MODEL} from '../Model/Models';
import AccessCodeTable from "./SubComponents/AccessCodeTable";
import {Trans} from "react-i18next";
import CancelModal from "./Modal/CancelModal";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const Schedule = ({subView, setSubView, modified, setModified, option, setOption}) => {

    const {
        t,
        DEV,
        permission,
        deleteModalShow,
        selectForDelete,
        setSelectForDelete,
        cancelModalShow,
        handleDeleteSelected,
        handleCancelSelected,
        handleBtnMeals,
        handleBtnShifts,
        handleDeleteModalClose,
        handleCancelModalClose,
        handleBtnAccessCode,
        selectForCancel,
        setSelectForCancel,
        isAllChecked,
        setIsAllChecked,
    } = ScheduleApp({
        setSubView,
        setModified,
        option,
        setOption
    });

    return (
        <>

            {subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS && (DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_READ) ) &&
                <Shifts
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                    optionView={subView}
                    modified={modified}
                    setModified={setModified}
                    handleBtnShifts={handleBtnShifts}
                    handleBtnMeals={handleBtnMeals}
                    handleBtnAccessCode={handleBtnAccessCode}
                    option={option}
                />
            }

            {subView === SUB_VIEW_MODEL.SCHEDULE.MEALS && ( DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_READ) ) &&
                <MealsTable
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    optionView={subView}
                    modified={modified}
                    setModified={setModified}
                    handleBtnShifts={handleBtnShifts}
                    handleBtnMeals={handleBtnMeals}
                    handleBtnAccessCode={handleBtnAccessCode}
                    option={option}
                />
            }

            {subView === SUB_VIEW_MODEL.SCHEDULE.ACCESS_CODE && ( DEV || permission?.includes(permissionObj?.WEB_FOODIE_ACCESS_READ) ) &&
                <AccessCodeTable
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                    selectForCancel={selectForCancel}
                    setSelectForCancel={setSelectForCancel}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    optionView={subView}
                    modified={modified}
                    setModified={setModified}
                    handleBtnShifts={handleBtnShifts}
                    handleBtnMeals={handleBtnMeals}
                    handleBtnAccessCode={handleBtnAccessCode}
                    DEV={DEV}
                    permission={permission}
                    option={option}
                />
            }

            {deleteModalShow &&
                <DeleteModal
                    title_modal={ subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS ?
                                    'delete_dining_shift'
                                : subView === SUB_VIEW_MODEL.SCHEDULE.MEALS ?
                                    'delete_service_time'
                                :   'delete_access_code'
                    }
                    show={deleteModalShow}
                    onHide={() => {
                        handleDeleteModalClose()
                    }}
                    onClickFn={() => {
                        handleDeleteSelected()
                    }}
                    buttonCancelText='cancel'
                    data={selectForDelete}
                    isReset={setSelectForDelete}
                    isAllReset={setIsAllChecked}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t(subView === SUB_VIEW_MODEL.SCHEDULE.SHIFTS ?
                                        'shifts'
                                        : subView === SUB_VIEW_MODEL.SCHEDULE.MEALS
                                        ? 'meals'
                                        : 'access_codes'
                    )
                    }
                />
            }

            {cancelModalShow &&
                <CancelModal
                    show={cancelModalShow}
                    onHide={() => {
                        handleCancelModalClose()
                    }}
                    onConfirm={(e, description) => {
                        handleCancelSelected(description)
                    }}
                    title_modal={'cancel_access_code'}
                    description={<Trans
                        i18nKey="are_you_sure_you_want_to_cancel_this_access_code"
                        components={{bold: <strong/> }}
                    />}
                    subDescription={t('please_provide_a_reason').toUpperCase()}
                />
            }
        </>
    );
}

export default Schedule;
